import React, { useState, useEffect } from "react";
import CustomPopupForm from "../customPopupModel";
import BasicCustomTable from "../basicTable";
import CustomButton from "../elements/CustomButton/CustomButton";
import axiosInstance from "../../configuration/request";
import { roleColumns, roleRows } from "../../constants/rbacManagement";
import { useSelector } from "react-redux";
import { getRbscManagementPermissions } from "../../utils/rolesAndPermissions";

const DIALOG_TYPES = {
  CREATE: "create-role",
  ASSIGN: "assign-role",
};

function AssignRole({ usertype, storeId }) {
  const [role, setRole] = useState([]);
  const [selectedRow, setSelectedRow] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [dialogType, setDialogType] = useState("");
  const permissions = useSelector((state) => state.counter.permissions);
  const rolePermissions = permissions?.[0]?.permissions || [];
  const { canEdit, canCreate } = getRbscManagementPermissions(rolePermissions);

  useEffect(() => {
    fetchRole();
  }, []);

  const finalColumns = React.useMemo(() => {
    if (!canEdit) {
      return roleColumns.filter((col) => col.field !== "action");
    }
    return roleColumns;
  }, [canEdit]);

  const fetchRole = async () => {
    try {
      let url = ``;
      if (usertype === "business user" && storeId) {
        url += `/auth/rbac/roles?storeId=${storeId}`;
      } else if (usertype === "admin") {
        url = `/auth/rbac/roles`;
      }
      const res = await axiosInstance.get(url);
      const formattedRole = res?.data?.map((item) => ({
        id: item.id,
        rbac_role: item?.name,
        users: item?.users?.length || 0,
        usersList: item?.users,
        resources_assign: item.permissions.map((perm) => {
          const resourcePart =
            usertype === "business user"
              ? perm?.resource?.split(":")[1]?.replace(/_/g, " ")
              : perm?.resource;

          return `${resourcePart}:${perm.action.join(",")}`;
        }),
      }));
      setRole(formattedRole);
    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedRow(null);
  };

  const handleCreate = () => {
    setDialogType(DIALOG_TYPES.CREATE);
    setOpenDialog(true);
  };

  const handleAddEmployee = (row) => {
    setDialogType(DIALOG_TYPES.ASSIGN);
    setOpenDialog(true);
    setSelectedRow(row);
  };

  const handleSubmit = () => {
    handleCloseDialog();
    fetchRole();
  };

  return (
    <div className="px-4 pb-2">
      <div className="flex justify-end items- w-full my-2 pr-1">
        {canCreate && (
          <CustomButton
            onClick={() => handleCreate()}
            customeClass="gradient-button w-[140px] h-[45px]"
          >
            <span className="text-xl mr-[4px]">+</span>Create
          </CustomButton>
        )}
      </div>
      <BasicCustomTable
        columns={finalColumns}
        rows={role}
        colorHeader={false}
        onAddEmpoyee={handleAddEmployee}
        customClassHeader={"table-header-center"}
        tableName="role"
        frontendPagination={true}
          pageLimit={10}
        maxHeightClass="max-h-[calc(100vh-325px)]"
        canEdit={canEdit}
      />
      {dialogType === DIALOG_TYPES.CREATE && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.CREATE}
          onSubmit={handleSubmit}
          dialogDetails={{
            userType: usertype,
            storeId: storeId,
          }}
        />
      )}
      {dialogType === DIALOG_TYPES.ASSIGN && (
        <CustomPopupForm
          isOpen={openDialog}
          handleClose={handleCloseDialog}
          dialogType={DIALOG_TYPES.ASSIGN}
          onSubmit={handleSubmit}
          // dialogDetails={selectedRow}
          dialogDetails={{
            selectedRow: selectedRow,
            userType: usertype,
            storeId: storeId,
          }}
        />
      )}
    </div>
  );
}

export default AssignRole;
